export const checkLogType = (logType: string, type: string) => {
  const logTypeMap: { [key: string]: string } = {
    CREATE: "+",
    MARKETING_CREATE: "+",
    PUB_USE: "-",
    PUB_WITHDRAW: "+",
    USER_USE: "+",
    PUB_USE_CANCEL: "+",
    USER_USE_CANCEL: "-",
    PUB_TO_USER: "-",
    USER_TO_PUB: "+",
    ISSUED: "+",
    RECOVERED: "-",
    TOURNAMENT_REFUND: "+",
    ADMIN_TOURNAMENT_REWARD: "+",
    ADMIN_TOURNAMENT_REFUND: "-",
    RESERVATION_WITHDRAW: type === "SEED" ? "+" : "소멸",
    RESERVATION_WITHDRAW_CANCEL: "-",
    ADMIN_TOURNAMENT_RESULT: "-",
    ADMIN_TOURNAMENT_RESULT_CANCEL: "+",
    REWARDED: "-",
    REWARD_CANCELLED: "+",
    BOUNTY: "-",
    RESERVATION_DISCOUNT: "-",
    RESERVATION_DISCOUNT_CANCEL: "+",
    PUB_TICKET_BUY: "-",
    PUB_TICKET_REFUND: "+",
    USER_TICKET_BUY: "+",
    USER_TICKET_BUY_CANCEL: "-",
  };

  return logTypeMap[logType] || logType;
};

export const formatLogType = (logType: string) => {
  const logTypeMap: { [key: string]: string } = {
    CREATE: "발행",
    MARKETING_CREATE: "발행",
    PUB_USE: "지급",
    PUB_WITHDRAW: "회수",
    USER_USE: "사용",
    PUB_USE_CANCEL: "지급 취소",
    USER_USE_CANCEL: "사용 취소",
    PUB_TO_USER: "펍에서 유저 수동 지급",
    USER_TO_PUB: "본방회수",
    ISSUED: "발행",
    RECOVERED: "회수",
    USER_CREATE_CANCEL: "유저 래빗 발행 취소",
    TOURNAMENT_REFUND: "시상대기 환급",
    ADMIN_TOURNAMENT_REWARD: "토너먼트 상금 지급 (본사)",
    ADMIN_TOURNAMENT_REFUND: "토너먼트 상금 지급 취소 (본사)",
    RESERVATION_WITHDRAW: "사용 (예약)",
    RESERVATION_WITHDRAW_CANCEL: "사용 취소 (예약)",
    ADMIN_TOURNAMENT_RESULT: "토너먼트 상금 지급 (본사)",
    ADMIN_TOURNAMENT_RESULT_CANCEL: "토너먼트 상금 지급 취소 (본사)",
    REWARDED: "상금 지급",
    REWARD_CANCELLED: "상금 지급 취소",
    BOUNTY: "바운티 지급",
    RESERVATION_DISCOUNT: "예약 할인",
    RESERVATION_DISCOUNT_CANCEL: "예약 할인 취소",
    PUB_TICKET_BUY: "티켓 교환",
    PUB_TICKET_REFUND: "티켓 환불",
    USER_TICKET_BUY: "유저 티켓 교환",
    USER_TICKET_BUY_CANCEL: "유저 티켓 교환 취소",
  };

  return logTypeMap[logType] || logType;
};
